import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
import Search from '@/views/Search.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '研报',
      keepAlive: true,
    },
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
    meta: {
      title: '研报搜索',
      keepAlive: true,
    },
  },
  {
    path: '/rank',
    name: 'rank',
    component: () => import(/* webpackChunkName: "rank" */ '../views/Rank.vue'),
    meta: {
      title: '研报排行榜',
    },
  },
  {
    path: '/myFollow',
    name: 'myFollow',
    component: () => import(/* webpackChunkName: "follow" */ '../views/MyFollow.vue'),
    meta: {
      title: '我的关注',
    },
  },
  {
    path: '/mainPage',
    name: 'mainPage',
    component: () => import(/* webpackChunkName: "main" */ '../views/AnalystAndAgency.vue'),
    meta: {
      title: '主页',
    },
  },
  {
    path: '/iframe',
    name: 'iframe',
    component: () => import(/* webpackChunkName: "iframe" */ '../views/KlineFrame.vue'),
  },
  {
    path: '/stockPage',
    name: 'stockPage',
    component: () => import(/* webpackChunkName: "stockpage" */ '../views/StockPage.vue'),
    meta: {
      title: '主页',
    },
  },
  {
    path: '/hotBlock',
    name: 'hotBlock',
    component: () => import(/* webpackChunkName: "hotBlock" */ '../views/HotBlock.vue'),
    meta: {
      title: 'ᅟ',
    },
  },
  {
    path: '/exploreReport',
    name: 'exploreReport',
    component: () => import(/* webpackChunkName: "exploreReport" */ '../views/ExploreReport.vue'),
    meta: {
      title: 'ᅟ',
    },
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 返回上一次滚动条保存的位置信息
    return (
      savedPosition || {
        x: 0,
        y: 0,
      }
    );
  },
});

/*路由守卫*/
router.beforeEach((to, from, next) => {
  // 不同客户端的针对title的处理
  let title = '';
  if (to.query.org) {
    title = `${to.query.name} - ${to.query.org}`;
  } else if (!to.query.org && to.query.name) {
    title = to.query.name as string;
  } else {
    title = to.meta.title;
  }
  // IOS处理
  if (title) {
    document.title = title;
    if (/hexin/gi.test(navigator.userAgent)) {
      if (navigator.userAgent.toLowerCase().indexOf('android') >= 0) {
        window.callNativeHandler('changeWebViewTitle', {
          title,
          url: '',
        });
      } else {
        window.callNativeHandler('updateTitleAutomatically');
      }
    }
  }
  next();
});

export default router;
